import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface MonitResultSelectedRowId {
  areaId: string;
  requestId: number;
}

/**
 * Serviço para armazenar temporariamente o ID da linha selecionada
 * para destacá-la visualmente após retornar da navegação
 */
@Injectable({
  providedIn: 'root',
})
export class MonitoringResultsStateService {
  private readonly STORAGE_KEY = 'monitoring_selected_row_id';
  private selectedRowIdSubject =
    new BehaviorSubject<MonitResultSelectedRowId | null>(this.getStoredRowId());
  public selectedRowId$ = this.selectedRowIdSubject.asObservable();

  /**
   * Obtém o ID armazenado no sessionStorage
   */
  private getStoredRowId(): MonitResultSelectedRowId | null {
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      return stored ? (JSON.parse(stored) ?? null) : null;
    } catch (error) {
      console.error('Erro ao ler sessionStorage:', error);
      return null;
    }
  }

  /**
   * Define o ID da área selecionada (temporário para destaque visual)
   */
  setSelectedRowId(areaId: MonitResultSelectedRowId | null): void {
    try {
      if (areaId !== null) {
        sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(areaId));
      } else {
        sessionStorage.removeItem(this.STORAGE_KEY);
      }
      this.selectedRowIdSubject.next(areaId);
    } catch (error) {
      console.error('Erro ao salvar no sessionStorage:', error);
    }
  }

  /**
   * Obtém o ID da área de monitoramento selecionada
   */
  getSelectedRowId(): MonitResultSelectedRowId | null {
    return this.selectedRowIdSubject.value;
  }

  /**
   * Limpa a seleção (chamado após timeout ou ao aplicar novos filtros)
   */
  clearSelection(): void {
    this.setSelectedRowId(null);
  }
}
